import { FETCH_REFILL, RESET_REFILL } from "../../constants/action.constants";

const initialState = {
  data: {},
};

const refillViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_REFILL:
      return { data: action.payload };
    case RESET_REFILL:
      return initialState;
    default:
      return state;
  }
};

export default refillViewReducer;
